// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {updateStatusByContractList} from "../../../Contract/ContractClient";
import {changeWorkQueue} from "../../workQueueSlice";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";


// main function
export default function DeferContract({ onMenuClose, rowContractData, selectorContractList }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);



    const handleDefer = () => {
        onMenuClose();
        updateStatusByContractList(selectorContractList, 'Deferred')
            .then(() => {
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
            });
    };

    return (

        <Box>
            {(rowContractData.contractLevel === "Guild" &&
                    rowContractData.contractStatus !== "Deferred" &&
                    rowContractData.contractStatus !== "Approved")
                &&
                <MenuItem onClick={handleDefer}>
                    <ListItemIcon>
                        <QuestionMarkIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Defer</ListItemText>
                </MenuItem>}
        </Box>

    )

}
